import {
  Activity,
  AppWindow,
  Archive,
  Building2,
  CalendarCheck,
  CalendarDays,
  Contact,
  FileText,
  Home,
  Layers,
  LifeBuoy,
  Mail,
  Settings,
  Tags,
  UsersRound,
} from "lucide-react";
import type { ComponentType } from "react";
import type { OrgUserRole } from "@/types/firestore";

export interface PlatformNavItem {
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
  end?: boolean;
}

export interface PlatformNavSection {
  label: string;
  items: PlatformNavItem[];
}

/**
 * Every current `/admin/*` destination, grouped for readability. Grouping is
 * presentation only — no destination is hidden and no route changes.
 */
export function platformNavSections(): PlatformNavSection[] {
  return [
    {
      label: "Management",
      items: [
        { label: "Dashboard", to: "/admin", icon: Home, end: true },
        { label: "Organizations", to: "/admin/orgs", icon: Building2 },
        { label: "Workspaces", to: "/admin/studios", icon: Layers },
        { label: "Apps", to: "/admin/apps", icon: AppWindow },
      ],
    },
    {
      label: "Outreach",
      items: [
        { label: "Communications", to: "/admin/communications", icon: Mail },
        { label: "Content", to: "/admin/content", icon: FileText },
        { label: "Contacts", to: "/admin/contacts", icon: Contact },
        { label: "Workshops", to: "/admin/workshops", icon: CalendarDays },
      ],
    },
    {
      label: "Administration",
      items: [
        { label: "Resources", to: "/admin/resources", icon: Archive },
        { label: "Platform Team", to: "/admin/team", icon: UsersRound },
        { label: "Settings", to: "/admin/settings", icon: Settings },
        { label: "Pickaxe Drift", to: "/admin/pickaxe-drift", icon: Activity },
      ],
    },
    {
      label: "BiG-Support",
      items: [
        { label: "Internal Support", to: "/admin/support/internal", icon: LifeBuoy },
        { label: "Support Tickets", to: "/admin/support/tickets", icon: LifeBuoy },
        { label: "Support Agreements", to: "/admin/support/agreements", icon: LifeBuoy },
        { label: "Rate Cards", to: "/admin/support/rate-cards", icon: Tags },
        { label: "Month-end Close", to: "/admin/support/close", icon: CalendarCheck },
        { label: "Support Settings", to: "/admin/support/settings", icon: LifeBuoy },
      ],
    },
  ];
}

export const platformRoleLabels: Partial<Record<OrgUserRole, string>> = {
  PLATFORM_OWNER: "Platform Owner",
  PLATFORM_ADMIN: "Platform Admin",
};
